var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconSubgroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.1179 8.72623C18.2203 17.5573 2.4776 21.0883 0.776799 8.72623C0.681421 -0.0979981 16.4308 -3.62899 18.1179 8.72623Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4606 7.25513L10.896 6.74902C9.16602 8.41946 7.83679 9.74304 6.94302 10.7726C6.16635 11.6784 6.10177 11.8844 6.26065 12.0372C6.30116 12.0768 6.35621 12.0984 6.41317 12.0958C6.6651 12.0626 6.90314 11.961 7.10189 11.8021C7.33863 11.6391 7.54877 11.4407 7.72537 11.2137L9.72494 9.349L11.6955 7.50793L11.4606 7.25513Z",
    fill: "#664650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0539 7.21346H12.0246C11.9235 7.20225 11.8336 7.14318 11.7833 7.05464C11.7423 7.00761 11.6891 6.94297 11.5952 6.84883L11.407 6.70174C11.2993 6.64307 11.2267 6.53552 11.2129 6.41353C11.2129 6.14297 11.5127 5.9782 11.6483 5.91939C11.9482 5.78411 12.4661 5.73704 12.6777 6.04292C12.8047 6.28024 12.7817 6.56987 12.6188 6.78413C12.5114 7.01061 12.3009 7.17073 12.0539 7.21346Z",
    fill: "#664650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconSubgroup);
export default __webpack_public_path__ + "static/media/edit-icon-subgroup.76b283f36b578543325693140810f0f1.svg";
export { ForwardRef as ReactComponent };